import { HttpClient, HttpHeaders } from '@angular/common/http';
import { Inject, Injectable } from '@angular/core';
import { BASE_URL } from '../constants';
import { environment } from 'src/environments/environment';

@Injectable({
    providedIn: 'root'
})
export class DataService {
    readonly defaultAcceptContentType = "application/pdf,application/vnd.ms-word,image/*"

    // making an instance for Get Request
    constructor(
        private httpClient: HttpClient,
        @Inject(BASE_URL) private baseUrl: string) { }

    get<T>(apiUrl: string, data?: any) {
        return this.httpClient
            .get<T>(this.buildUrl(apiUrl), { headers: this.getDefaultHeaders() });
    }

    getById<T>(apiUrl: string, id?: any) {
        return this.httpClient
            .get<T>(this.buildUrl(apiUrl, id), { headers: this.getDefaultHeaders() })
    }

    post<T>(apiUrl: string, data: any) {
        return this.httpClient
            .post<T>(this.buildUrl(apiUrl), JSON.stringify(data), { headers: this.getDefaultHeaders() });
    }

    put<T>(apiUrl: string, data: any, id?: number) {
        return this.httpClient
            .put<T>(this.buildUrl(apiUrl, id), JSON.stringify(data), { headers: this.getDefaultHeaders() });
    }

    //this method used to call WebAPI for patch type. 
    patch<T>(apiUrl: string, data: any, id?: number) {
        return this.httpClient
            .patch<T>(this.buildUrl(apiUrl, id), data, { headers: this.getDefaultHeaders() });
    }

    delete<T>(apiUrl: string, id: any) {
        return this.httpClient
            .delete<T>(this.buildUrl(apiUrl, id), { headers: this.getDefaultHeaders() });
    }
    downloadFile(url: string, data: any, contentType: string) {
        var contentType = contentType ?? this.defaultAcceptContentType
        let finalUrl = this.buildUrl(url);
        let result = this.httpClient
            .post(finalUrl, JSON.stringify(data), {
                headers: this.getDefaultHeaders(contentType),
                responseType: 'arraybuffer',
                observe: "response" as 'body'
            });
        return result;
    }

    downloadRawFile(url: string) {
        let finalUrl = this.buildUrl(url);
        let result = this.httpClient
            .get<Blob>(finalUrl, { observe: 'response', responseType: 'blob' as 'json' });
        return result;
    }

    private getDefaultHeaders(accept: string = "application/json"): HttpHeaders {
        return new HttpHeaders()
            .append("accept", accept || "application/json")
            .append("Cache-Control", "no-store")
            .append("Pragma", "no-cache")
            .append("Expires", "-1")
            .append("If-Modified-Since", "0")
            .append("content-type", "application/json");
        // // .append("authorization",`Bearer ${sessionStorage.getItem(environment.ACCESS_TOKEN_KEY)}`);
    }

    private buildUrl(apiUrl: string, id?: any) {
        var url = `${this.baseUrl}${apiUrl}`;
        return (id === null || typeof (id) === 'undefined') ? url : `${url}/${encodeURIComponent(id)}`;
    }
}
